import React from 'react'
import ControlledTextArea from 'transfix-form/components/ControlledTextArea'
import Box from 'transfix-ui/core/Box'
import Grid from 'transfix-ui/core/Grid'
import { useCreateLoadFormContext } from 'apps/fleet-planner/context'

export const SectionNotes = () => {
  const { control } = useCreateLoadFormContext()

  return (
    <Box mb={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <ControlledTextArea
            name='notes'
            defaultValue=''
            control={control}
            TextAreaProps={{
              label: 'Notes',
              placeholder: 'Write something...',
              dataTest: 'load-details-notes',
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
